<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ title }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new pt-4 pb-6"
      :settings="settings"
    >
      <div class="p-6">
        <!-- NAME
        <vs-input label="Name" name="name" v-model="name" class="mt-5 w-full" />


        <vs-select v-model="category" label="Category" class="mt-5 w-full">
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in category_choices"
          />
        </vs-select>

        <vs-select v-model="order_status" label="Order Status" class="mt-5 w-full">
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in order_status_choices"
          />
        </vs-select>


        <vs-input label="Price" name="price" v-model="price" class="mt-5 w-full" />


        <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" />-->
        <formUser
          v-if="form == 'usuario'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formUser>

        <formRegional
          v-if="form == 'Escritorio'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formRegional>

        <formDivisao
          v-if="form == 'Corretora'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formDivisao>

        <FormConvenio
          v-if="form == 'Convenio'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></FormConvenio>

        <formSetor
          v-if="form == 'Setor'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formSetor>

        <formPerfil
          v-if="form == 'Perfil'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formPerfil>

        <formGrupo
          v-if="form == 'Grupo'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formGrupo>

        <formTipoPagamento
          v-if="form == 'TipoPagamento'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTipoPagamento>

        <formProduto
          v-if="form == 'Produto'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formProduto>

        <formTabela
          v-if="form == 'Tabela'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTabela>

        <formTabelaValor
          v-if="form == 'TabelaValores'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTabelaValor>

        <formTipoFoto
          v-if="form == 'TipoFoto'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTipoFoto>

        <formRestricao
          v-if="form == 'Restricoes'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formRestricao>

        <formTabelaEstadosCidades
          v-if="form == 'TabelaEstadosCidades'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTabelaEstadosCidades>

        <formContaBancaria
          v-if="form == 'ContaBancaria'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formContaBancaria>

        <formCotaParticipacao
          v-if="form == 'CotaParticipacao'"
          :sideBar="true"
          :dados="dadosSend"
          :tipo="'CotaParticipacoes'"
          :tipoCadastro="'Modelo'"
          :entidade="'CotaParticipacoes'"
          :pk="'idCotaParticipacao'"
          :isSideBar="true"
          @cancel="cancel"
          @concluido="concluido"
        ></formCotaParticipacao>

        <formVistoriador
          v-if="form == 'vistoriador'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formFornecedor
          v-if="form == 'Fornecedor'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formTipoFornecedor
          v-if="form == 'TipoFornecedor'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formSituacaoEvento
          v-if="form === 'SituaçãoEvento'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formMotivoEvento
          v-if="form === 'MotivoEvento'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formAgravoCep
          v-if="form === 'AgravoCep'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formAgravoProposta
          v-if="form === 'AgravoProposta'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formPriorInspection
          v-if="form === 'VistoriaPrevia'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formContrato
          v-if="form === 'Contratos'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <FormBrokerBlocklist
          v-if="form === 'BrokerBlocklist'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <FormOriginSystem
          v-if="form === 'OriginSystemForm'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :origin-system="dadosSend"
          :active="isSidebarActiveLocal"
        />

        <FormCongener
          v-if="form == 'Congener'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :congener="dadosSend"
          :active="isSidebarActiveLocal"
        />

        <FormProposalRefuseReason
          v-if="form == 'ProposalRefuseReason'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :proposalRefuseReason="dadosSend"
          :active="isSidebarActiveLocal"
        />
        <slot></slot>
      </div>
    </VuePerfectScrollbar>

    <!--div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6">Add Data</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div-->
  </vs-sidebar>
</template>

<script>
import FormOriginSystem from '@/views/menu/configuracoes/origin-system/components/FormOriginSystem.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import FormBrokerBlocklist from '../forms/FormBrokerBlocklist.vue';
import FormCongener from '../forms/FormCongener.vue';
import FormProposalRefuseReason from '../forms/FormProposalRefuseReason.vue';
import formContrato from '../forms/FormContrato.vue';
import formFornecedor from '../forms/FormFornecedor.vue';
import formPriorInspection from '../forms/FormPriorInspection.vue';
import formTipoFornecedor from '../forms/FormTipoFornecedor.vue';
import formVistoriador from '../forms/FormVistoriador.vue';
import formAgravoCep from '../menu/agravos/agravosCep/agravosCepForm.vue';
import formAgravoProposta from '../menu/agravos/agravosProposta/agravosPropostaForm.vue';
import formMotivoEvento from '../menu/eventos/motivos-evento/motivos-evento-form.vue';
import formSituacaoEvento from '../menu/eventos/situacoes-evento/situacoes-evento-form.vue';
import formUser from './../forms/FormAddUser';
import formContaBancaria from './../forms/FormContaBancaria';
import FormConvenio from './../forms/FormConvenio';
import formCotaParticipacao from './../forms/FormCotaParticipacao';
import formDivisao from './../forms/FormDivisao';
import formGrupo from './../forms/FormGrupo';
import formPerfil from './../forms/FormPerfil';
import formProduto from './../forms/FormProduto';
import formRegional from './../forms/FormRegional';
import formRestricao from './../forms/FormRestricao';
import formSetor from './../forms/FormSetor';
import formTabela from './../forms/FormTabela';
import formTabelaEstadosCidades from './../forms/formTabelaEstadosCidades';
import formTabelaValor from './../forms/FormTabelaValor';
import formTipoFoto from './../forms/FormTipoFoto';
import formTipoPagamento from './../forms/FormTipoPagamento';

export default {
  components: {
    VuePerfectScrollbar,
    formUser,
    formRegional,
    formDivisao,
    FormConvenio,
    formSetor,
    formPerfil,
    formGrupo,
    formTipoPagamento,
    formProduto,
    formTabela,
    formTabelaValor,
    formTipoFoto,
    formRestricao,
    formTabelaEstadosCidades,
    formContaBancaria,
    formCotaParticipacao,
    formVistoriador,
    formFornecedor,
    formTipoFornecedor,
    formSituacaoEvento,
    formMotivoEvento,
    formAgravoCep,
    formAgravoProposta,
    formPriorInspection,
    formContrato,
    FormBrokerBlocklist,
    FormOriginSystem,
    FormCongener,
    FormProposalRefuseReason,
  },
  props: {
    dados: {
      type: Object,
    },
    title: {
      type: String,
    },
    form: {
      type: String,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dadosSend: {},
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    // eslint-disable-next-line
    dados(value) {
      this.initValues();
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar');
        }
      },
    },
  },
  methods: {
    cancel() {
      this.isSidebarActiveLocal = false;
      //this.$emit("closeSidebar");
    },
    concluido() {
      this.isSidebarActiveLocal = false;
      this.$emit('concluido');
    },
    initValues() {
      this.dadosSend = this.dados;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
